'use strict';

var invariant = require('invariant');
var canUseDOM = require('can-use-dom');

/**
 * Returns the current scroll position of the window as { x, y }.
 */
function getWindowScrollPosition() {
  invariant(canUseDOM, 'Cannot get current scroll position without a DOM');

  return {
    x: window.pageXOffset || document.documentElement.scrollLeft,
    y: window.pageYOffset || document.documentElement.scrollTop
  };
}

module.exports = getWindowScrollPosition;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router/lib/getWindowScrollPosition.js
 ** module id = 193
 ** module chunks = 1
 **/